import { api } from "../api/api";
import { ApiResponse } from "../models/base/ApiResponse";
import { CreateTableDTO, UpdateTableDTO, UpdateTablePositionsDTO } from "../models/table/table.request";
import { LiveOrderTableDTO, LiveOrderTableInfoDTO, TableBasicInfoDTO, TableInfoDTO, TableSettingsInfoDTO, TableSettingsItemDTO } from "../models/table/table.response";



export const tableService = {

    async createTable(localId: string, dto: CreateTableDTO): Promise<ApiResponse<string>> {
        const { data } = await api.post<ApiResponse<string>>(`/locals/${localId}/tables`, dto);
        return data;
    },

    async getTablesByLocalId(localId: string): Promise<ApiResponse<TableSettingsItemDTO[]>> {
        const { data } = await api.get<ApiResponse<TableSettingsItemDTO[]>>(`/tables/local/${localId}`);
        return data;
    },

    async getTableById(localId: string, id: string): Promise<ApiResponse<TableSettingsInfoDTO>> {
        const { data } = await api.get<ApiResponse<TableSettingsInfoDTO>>(`/locals/${localId}/tables/${id}/settings`);
        return data;
    },

    async updateTable(localId: string, id: string, dto: UpdateTableDTO): Promise<ApiResponse<string>> {
        const { data } = await api.patch<ApiResponse<string>>(`/locals/${localId}/tables/${id}`, dto);
        return data;
    },

    async deleteTable(localId: string, id: string): Promise<ApiResponse<string>> {
        const { data } = await api.delete<ApiResponse<string>>(`/locals/${localId}/tables/${id}`);
        return data;
    },

    async getTablesInfoByLocalId(localId: string, isActive?: boolean, isReservable?: boolean, minCapacity?: number, maxCapacity?: number, take?: number): Promise<ApiResponse<TableInfoDTO[]>> {
        const { data } = await api.get<ApiResponse<TableInfoDTO[]>>(`/locals/${localId}/tables`, {
            params: {
                isActive,
                isReservable,
                minCapacity,
                maxCapacity,
                take
            }
        });
        return data;
    },

    async getLiveOrdersTablesByLocalId(localId: string): Promise<ApiResponse<LiveOrderTableDTO[]>> {
        const { data } = await api.get<ApiResponse<LiveOrderTableDTO[]>>(`/locals/${localId}/live-orders/tables`);
        return data;
    },

    async getLiveOrdersTableByLocalId(localId: string, tableId: string): Promise<ApiResponse<LiveOrderTableDTO>> {
        const { data } = await api.get<ApiResponse<LiveOrderTableDTO>>(`/locals/${localId}/live-orders/tables/${tableId}`);
        return data;
    },

    async updateTablePositions(localId: string, dtos: UpdateTablePositionsDTO[]): Promise<ApiResponse<string>> {
        const { data } = await api.patch<ApiResponse<string>>(`/locals/${localId}/tables/positions`, dtos);
        return data;
    },

    async getTableNumberById(tableId: string): Promise<ApiResponse<TableBasicInfoDTO>> {
        const { data } = await api.get<ApiResponse<TableBasicInfoDTO>>(`/tables/${tableId}/number`);
        return data;
    },

    async getLiveOrderTableInfoById(localId: string, tableId: string): Promise<ApiResponse<LiveOrderTableInfoDTO>> {
        const { data } = await api.get<ApiResponse<LiveOrderTableInfoDTO>>(`/locals/${localId}/tables/${tableId}/live-order/info`);
        return data;
    },

    async updateBackgroundImage(localId: string, form: FormData): Promise<ApiResponse<string>> {
        const { data } = await api.patch<ApiResponse<string>>(`/locals/${localId}/tables/background-image`, form);
        return data;
    },

    async getBackgroundImage(localId: string): Promise<ApiResponse<string>> {
        const { data } = await api.get<ApiResponse<string>>(`/locals/${localId}/tables/background-image`);
        return data;
    }

}